import { ExplorerApiErrorCodeSchema } from "@strust/contracts";
import type { IntlShape } from "react-intl";
import { errorMessages } from "../messages.ts";

/**
 * The SSO callback redirects to `/login?error=<code>`. Only known Explorer API codes map to text;
 * anything else (the parameter is user-controlled) shows the generic SSO failure.
 */
export function describeSsoRedirectError(intl: IntlShape, raw: string): string {
  const parsed = ExplorerApiErrorCodeSchema.safeParse(raw);
  if (parsed.success && parsed.data in errorMessages) {
    return intl.formatMessage(errorMessages[parsed.data as keyof typeof errorMessages]);
  }
  return intl.formatMessage(errorMessages.sso_failed);
}
